import RegistrationDetails from './RegistrationDetails';

export default RegistrationDetails;
